<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Trigger</h2>
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="macAddress">
              <the-mask
                class="el-input__inner"
                v-model="query.macAddress"
                :masked="true"
                mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)"
                @keyup.enter.native="load"
                :tokens="hexTokens"
              />
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
              filterable
                v-model="query.customer"
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="false" label="version">
              <el-input
                @keyup.enter.native="load"
                placeholder="Please input"
                v-model="query.version"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.triggers"
            class="border"
          >
            <el-table-column type="index" width="50" />
            <el-table-column prop="macAddress" label="macAddress" />
            <el-table-column
              prop="certificateId"
              label="Certificate Id"
              width="120px"
            >
              <template slot-scope="scope">
                <span @click="copyIdToClipboard(scope.row.certificateId)">
                  <abbr :title="scope.row.certificateId">{{
                    scope.row.certificateId
                  }}</abbr>
                </span>
              </template>
            </el-table-column>

            <el-table-column
              prop="customer"
              label="Customer"
              column-key="customer"
            >
            </el-table-column>
            <el-table-column prop="version" label="Version" width="100px;" />
            <el-table-column prop="versionRequestedAt" label="Version Requested At" width="200px;" />
          
          </el-table>
        </el-col>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";

export default {
  name: "Trigger",
  components: { TheMask },
  data() {
    let IsMacAddress = (rule, value, callback) => {
      if (
        !/^[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}$/g.test(
          value
        )
      ) {
        return callback(
          new Error("Please input proper mac address (ex: AB:CD:EF:12:34:56)")
        );
      }
      return callback();
    };
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      query: {
        macAddress: "",
        customer: "",
        //version: "",
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
      editId: "",
      showForm: false,
      formLoading: false,
      certs: {},
      showCertsForm: false,
      form: {
        macAddress: "",
      },
      rules: {
        macAddress: [
          {
            validator: IsMacAddress,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getTriggers(this.query);
    this.getCustomers();
  },
  computed: {
    ...mapState("trigger", ["searchResult", "loading"]),
    ...mapState("customer", ["customers"]),
    customerFilterSelect() {
      return this.$store.state.customer.customers.map((x) => {
        return {
          value: x._id,
          text: x.name,
        };
      });
    },
    customerSelect() {
      return this.$store.state.customer.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
  },
  methods: {
    load() {
      this.getTriggers(this.query);
    },
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    ...mapActions("trigger", [
      "getTriggers",
      "createTrigger",
      "updateTrigger",
      "deleteTrigger",
      "newCertTrigger",
    ]),
    ...mapActions("customer", ["getCustomers"]),
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>